import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStencilExpandGroups = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.88017 4.29065C6.14747 4.55796 6.58086 4.55796 6.84816 4.29065C7.11546 4.02335 7.11546 3.58996 6.84816 3.32266L4.0095 0.483997L3.5255 0L3.04151 0.483997L0.202847 3.32266C-0.0644574 3.58996 -0.0644574 4.02335 0.202847 4.29065C0.470151 4.55796 0.903537 4.55796 1.17084 4.29065L3.5255 1.93599L5.88017 4.29065ZM1.16847 7.93496C0.901168 7.66766 0.467783 7.66766 0.200478 7.93496C-0.0668261 8.20227 -0.0668261 8.63565 0.200478 8.90296L3.03914 11.7416L3.52313 12.2256L4.00713 11.7416L6.84579 8.90296C7.1131 8.63565 7.1131 8.20227 6.84579 7.93496C6.57849 7.66766 6.1451 7.66766 5.8778 7.93496L3.52313 10.2896L1.16847 7.93496Z",
		fill: "currentColor"
	})
});
export default SvgStencilExpandGroups;
